'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nanoStyle = require('nano-style');

var _nanoStyle2 = _interopRequireDefault(_nanoStyle);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _propTypes = require('prop-types');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XRay = (0, _nanoStyle2.default)('div')(function (_ref) {
  var padding = _ref.padding,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      outline = _ref.outline,
      grid = _ref.grid,
      center = _ref.center,
      disabled = _ref.disabled,
      style = _ref.style;
  return disabled ? (0, _objectAssign2.default)({}, style, { padding: padding }) : (0, _objectAssign2.default)({}, style, {
    padding: padding,
    color: color,
    backgroundColor: backgroundColor,
    backgroundPosition: center ? 'center center' : 'left top',
    '& *': {
      color: outline ? color + ' !important' : null,
      outline: outline ? '1px solid ' + (0, _util.alpha)(color, 1 / 2) + ' !important' : null,
      backgroundColor: outline ? (0, _util.alpha)(color, 1 / 8) + ' !important' : null
    }
  }, getGrid(grid, (0, _util.alpha)(color, 1 / 4)));
});

var getGrid = function getGrid(grid, color) {
  if (!grid) return null;
  var size = grid && typeof grid === 'number' ? grid : 8;
  return {
    backgroundImage: (0, _util.gradient)(0, size, color) + ', ' + (0, _util.gradient)(90, size, color),
    backgroundSize: size + 'px ' + size + 'px'
  };
};

XRay.propTypes = {
  padding: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  color: _propTypes.string,
  backgroundColor: _propTypes.string,
  outline: _propTypes.bool,
  grid: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.bool]),
  center: _propTypes.bool
};

XRay.defaultProps = {
  padding: 0,
  outline: true,
  grid: 8,
  color: '#6bf',
  backgroundColor: '#001424',
  center: false
};

exports.default = XRay;


//////////////////
// WEBPACK FOOTER
// ./~/react-x-ray/dist/XRay.js
// module id = 15
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818